/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  DISTRIBUTORS_REQUEST,
  DISTRIBUTORS_SUCCESS,
  DISTRIBUTORS_FAILURE,
  SWITCH_DISTRIBUTOR
} from 'src/store/actions/distributorActions';
import { LOGOUT } from 'src/store/actions/accountActions';
import axios from 'src/http/fetchClient';

const initialState = {
  distributors: null,
  activeDistributor: null
};

const distributorReducer = (state = initialState, action) => {
  switch (action.type) {
    case DISTRIBUTORS_REQUEST: {
      return produce(state, (draft) => {
        draft.distributors = null;
      });
    }

    case DISTRIBUTORS_SUCCESS: {
      const { distributors } = action.payload;
      return produce(state, (draft) => {
        draft.distributors = distributors || [];
        const switchDistributor =
          state.activeDistributor == null ||
          !distributors?.length ||
          distributors.filter((distributor) => distributor.id === state.activeDistributor.id).length === 0;

        if (switchDistributor && distributors?.length > 0) {
          const [firstDistributor] = distributors;
          draft.activeDistributor = firstDistributor;
          localStorage.setItem('activeDistributorId', firstDistributor.id);
        } else if (state.activeDistributor) {
          localStorage.setItem('activeDistributorId', state.activeDistributor.id);
        }
      });
    }

    case DISTRIBUTORS_FAILURE: {
      return produce(state, (draft) => {
        draft.distributors = null;
        draft.activeDistributor = null;
        localStorage.removeItem('activeDistributorId');
      });
    }

    case SWITCH_DISTRIBUTOR: {
      const { distributor } = action.payload;

      return produce(state, (draft) => {
        draft.activeDistributor = distributor;
        localStorage.setItem('activeDistributorId', distributor.id);
      });
    }

    case LOGOUT: {
      return produce(state, (draft) => {
        draft.distributors = null;
        draft.activeDistributor = null;
        localStorage.removeItem('activeDistributorId');
      });
    }

    default: {
      return state;
    }
  }
};

export default distributorReducer;
